module.exports = __webpack_public_path__ + "img/17.f1ab2854.png";